import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useIsNativeEContentAvailable } from 'app/helpers/econtent/nativeEContentBridge';

/**
 * Label for the checked-out fulfilment CTA. Shows "Read now" only inside the native
 * app (eContent capability present) and keeps the existing "Access this item" on web,
 * so the eReader rollout is transparent to web users. SSR-safe (see the hook).
 */
export default function ReadNowLabel() {
  const isNativeEContent = useIsNativeEContentAvailable();
  return <FormattedMessage id={isNativeEContent ? 'read_now' : 'access_this_item'} />;
}
